const ADMIN_NAMES = {
  'shubhamgotrale@gmail.com': 'Shubham',
  '100rabhgotrale@gmail.com': 'Sourabh',
};

export const getAdminDisplayName = (user) =>
  ADMIN_NAMES[user?.email?.toLowerCase()] || user?.name || 'Admin';
